export function getFormattedAliasNumber(alias: string) {
    let sum = 0;
    let lastDigit = 0;
    for (let i = 0; i < alias.length; i += 1) {
      sum += Number(alias.charAt(i));
    }
    lastDigit = sum % 10;
    return `${alias.substring(0, 5)}-${alias.substring(5)}-${lastDigit}`;
}